export default "__VITE_ASSET__CrRXm6Z1__"